module.exports = __webpack_public_path__ + "static/GMDN-GMDTV-09358e5e387b4920db3f3c9a16b49880.pdf";